// Generated from build58 src/features/taste/decades.ts. Run scripts/generate-taste-reference.cjs.
// Fill the timeline, not the statistics: missing decades have an explicit zero.
export const DECADE_ITEM_WIDTH = 78;
export function decadeScrollOffset(items, viewportWidth, contentWidth, contentInset = 0) {
  if (!items.length || viewportWidth <= 0) return 0;
  const strongest = items.reduce(
    (best, item, index) => (item.count > items[best].count ? index : best),
    0,
  );
  return Math.max(
    0,
    Math.min(
      contentWidth - viewportWidth,
      contentInset + (strongest + 0.5) * DECADE_ITEM_WIDTH - viewportWidth / 2,
    ),
  );
}
// Keep older/future buckets returned by the API rather than silently discarding them.
export function completeDecades(items, year = new Date().getFullYear()) {
  const counts = new Map();
  for (const item of items) {
    const decade = Number.parseInt(item.label, 10);
    if (Number.isFinite(decade)) counts.set(decade, item.count);
  }
  const current = Math.floor(year / 10) * 10;
  for (let decade = 1950; decade <= current; decade += 10) {
    if (!counts.has(decade)) counts.set(decade, 0);
  }
  return [...counts]
    .sort(([a], [b]) => a - b)
    .map(([decade, count]) => ({ label: `${decade}년대`, count }));
}
